import { useMemo, useState } from "react";
import { FieldValues, UseFormReturn } from "react-hook-form";
import styled from "styled-components";
import { z } from "zod";
import { Button } from "../../atoms/Button";
import { Input } from "../../atoms/Input";
import FormTemplate from "../../templates/FormTemplate";

type Props = {
  handleSubmit: (code: string, phoneNumber: string) => void;
};

export const ChangeEmailForm: React.FC<Props> = ({ handleSubmit }) => {
  const schema = useMemo(() => {
    return z.object({
      code: z.string().min(1),
      phoneNumber: z.string().min(1),
    });
  }, []);

  const [methods, setMethods] = useState<UseFormReturn<
    FieldValues,
    any,
    undefined
  > | null>(null);

  return (
    <FormTemplate
      schema={schema}
      setMethods={setMethods}
      defaultValues={{ code: "" }}
      onSubmit={({ code, phoneNumber }) => handleSubmit(code, phoneNumber)}
    >
      <Message>※印は必須項目です。</Message>
      <ContentWrapper>
        <Input
          name="code"
          type="text"
          label="認証コード"
          helperText="メールに記載されている認証コードを入力して下さい"
          labelBorderBottom
          required
          dataWovnIgnore={true}
        />
      </ContentWrapper>
      <ContentWrapper>
        <Input
          name="phoneNumber"
          type="text"
          label="電話番号を入力してください"
          labelBorderBottom
          required
          dataWovnIgnore={true}
        />
      </ContentWrapper>

      <ButtonWrapper>
        <Button btnStyle="primary" text="登録内容を変更する" type="submit" />
      </ButtonWrapper>
    </FormTemplate>
  );
};

const ContentWrapper = styled.div`
  margin-bottom: 40px;
  white-space: pre-line;
`;

const Message = styled.div`
  text-align: left;
  margin-bottom: 26px;
  font-size: 14px;
  font-weight: 300;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 80px 30px 0;
  button {
    height: auto;
    line-height: 1;
  }
`;
